import { N_, idioma, t } from './i18n';

// Moeda e números no padrão do país do aparelho (o app é usado no mundo todo).
const POR_PAIS: Record<string, string> = {
  BR: 'BRL', PT: 'EUR', ES: 'EUR', FR: 'EUR', DE: 'EUR', IT: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR', IE: 'EUR', FI: 'EUR', GR: 'EUR', LU: 'EUR',
  US: 'USD', GB: 'GBP', CA: 'CAD', AU: 'AUD', NZ: 'NZD', CH: 'CHF', JP: 'JPY', CN: 'CNY', HK: 'HKD', TW: 'TWD', KR: 'KRW', IN: 'INR', BD: 'BDT',
  PK: 'PKR', ID: 'IDR', MY: 'MYR', SG: 'SGD', TH: 'THB', PH: 'PHP', VN: 'VND', RU: 'RUB', UA: 'UAH', PL: 'PLN', CZ: 'CZK', SE: 'SEK', NO: 'NOK',
  DK: 'DKK', TR: 'TRY', IL: 'ILS', SA: 'SAR', AE: 'AED', EG: 'EGP', ZA: 'ZAR', NG: 'NGN', KE: 'KES', MA: 'MAD', AO: 'AOA', MZ: 'MZN',
  AR: 'ARS', CL: 'CLP', CO: 'COP', MX: 'MXN', PE: 'PEN', UY: 'UYU', PY: 'PYG', BO: 'BOB', VE: 'VES',
};
export const MOEDAS = [...new Set(['BRL', 'USD', 'EUR', 'GBP', ...Object.values(POR_PAIS)])];

/** País do aparelho (BR, US, PT...), pelo idioma/região do sistema. */
export function paisAparelho(): string {
  try {
    const loc = Intl.DateTimeFormat().resolvedOptions().locale || '';
    const m = loc.match(/[-_]([A-Z]{2})\b/);
    if (m) return m[1];
  } catch { /* sem Intl */ }
  const i = idioma();
  return i === 'pt-BR' ? 'BR' : i === 'pt-PT' ? 'PT' : i === 'en' ? 'US' : i === 'es' ? 'ES' : i === 'fr' ? 'FR' : i === 'it' ? 'IT' : i === 'de' ? 'DE'
    : i === 'zh' ? 'CN' : i === 'ja' ? 'JP' : i === 'hi' ? 'IN' : i === 'bn' ? 'BD' : i === 'ru' ? 'RU' : i === 'id' ? 'ID' : i === 'ar' ? 'SA' : 'US';
}
export const moedaPadrao = () => POR_PAIS[paisAparelho()] ?? 'USD';

const LOCALE: Record<string, string> = { 'pt-BR': 'pt-BR', 'pt-PT': 'pt-PT', en: 'en-US', es: 'es-ES', fr: 'fr-FR', it: 'it-IT', de: 'de-DE', zh: 'zh-CN', ja: 'ja-JP', hi: 'hi-IN', bn: 'bn-BD', ru: 'ru-RU', id: 'id-ID', ar: 'ar-SA' };
const cache = new Map<string, Intl.NumberFormat>();
/** "R$ 1.234,56", "$1,234.56", "€1.234,56"... */
export function dinheiro(v: number, moeda: string) {
  const k = `${idioma()}|${moeda}`;
  let f = cache.get(k);
  if (!f) {
    try { f = new Intl.NumberFormat(LOCALE[idioma()] ?? 'en-US', { style: 'currency', currency: moeda || 'USD' }); }
    catch { f = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
    cache.set(k, f);
  }
  try { return f.format(v); } catch { return `${moeda} ${v.toFixed(2)}`; }
}

/** Lê "1.234,56", "1,234.56", "1234.5" ou "1234" (respeita o separador decimal do idioma). */
export function lerValor(txt: string): number {
  const s = txt.replace(/[^\d.,-]/g, '').trim();
  if (!s) return NaN;
  const temV = s.includes(','), temP = s.includes('.');
  let dec: ',' | '.';
  if (temV && temP) dec = s.lastIndexOf(',') > s.lastIndexOf('.') ? ',' : '.';
  else if (temV) dec = ',';
  else if (temP) dec = /^(pt|es|fr|it|de|ru|id)/.test(idioma()) && /\.\d{3}$/.test(s) ? ',' : '.';
  else return Number(s);
  return Number(dec === ',' ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, ''));
}

// ─── Lista de moedas (0.67.2, texto 07 C4): busca, "Mais usadas", a do país e "Todas" por nome ───
/** Bloco "Mais usadas", nesta ordem. */
export const MOEDAS_MAIS_USADAS = ['BRL', 'USD', 'EUR', 'GBP', 'JPY', 'CNY', 'CHF', 'CAD', 'AUD', 'MXN', 'ARS', 'INR'];
/** Nomes em português (para quando o celular não sabe dar o nome no idioma do app: Intl.DisplayNames). */
const NOMES: Record<string, string> = {
  BRL: N_('Real brasileiro'), EUR: N_('Euro'), USD: N_('Dólar americano'), GBP: N_('Libra esterlina'), CAD: N_('Dólar canadense'),
  AUD: N_('Dólar australiano'), NZD: N_('Dólar neozelandês'), CHF: N_('Franco suíço'), JPY: N_('Iene japonês'), CNY: N_('Yuan chinês'),
  HKD: N_('Dólar de Hong Kong'), TWD: N_('Novo dólar taiwanês'), KRW: N_('Won sul-coreano'), INR: N_('Rupia indiana'), BDT: N_('Taka bengali'),
  PKR: N_('Rupia paquistanesa'), IDR: N_('Rupia indonésia'), MYR: N_('Ringgit malaio'), SGD: N_('Dólar de Singapura'), THB: N_('Baht tailandês'),
  PHP: N_('Peso filipino'), VND: N_('Dong vietnamita'), RUB: N_('Rublo russo'), UAH: N_('Hryvnia ucraniana'), PLN: N_('Zloty polonês'),
  CZK: N_('Coroa tcheca'), SEK: N_('Coroa sueca'), NOK: N_('Coroa norueguesa'), DKK: N_('Coroa dinamarquesa'), TRY: N_('Lira turca'),
  ILS: N_('Novo shekel israelense'), SAR: N_('Riyal saudita'), AED: N_('Dirham dos Emirados Árabes Unidos'), EGP: N_('Libra egípcia'),
  ZAR: N_('Rand sul-africano'), NGN: N_('Naira nigeriana'), KES: N_('Xelim queniano'), MAD: N_('Dirham marroquino'), AOA: N_('Kwanza angolano'),
  MZN: N_('Metical moçambicano'), ARS: N_('Peso argentino'), CLP: N_('Peso chileno'), COP: N_('Peso colombiano'), MXN: N_('Peso mexicano'),
  PEN: N_('Sol peruano'), UYU: N_('Peso uruguaio'), PYG: N_('Guarani paraguaio'), BOB: N_('Boliviano'), VES: N_('Bolívar venezuelano'),
};
const nomesCache = new Map<string, string>();
/** Nome da moeda no idioma do app ("Dólar americano"): o do celular (Intl.DisplayNames); senão, a tabela acima; senão, o código. */
export function nomeMoeda(x: string, lang: string = idioma()) {
  const k = `${lang}|${x}`;
  const c = nomesCache.get(k);
  if (c) return c;
  let n = '';
  try {
    const DN = (Intl as any).DisplayNames;
    if (DN) { const v = new DN([lang], { type: 'currency' }).of(x); if (v && v !== x) n = v.charAt(0).toUpperCase() + v.slice(1); }
  } catch { /* sem Intl.DisplayNames */ }
  if (!n) n = NOMES[x] ? t(NOMES[x]) : x;
  nomesCache.set(k, n);
  return n;
}
/** "R$", "US$", "€"... (o símbolo que o próprio app usa); quando o celular só conhece o código, devolve ''. */
export function simboloMoeda(x: string) {
  const s = dinheiro(0, x).replace(/[\d\s.,\u00A0\u202F\u0660-\u0669-]/g, '').trim();
  return s && s.toUpperCase() !== x.toUpperCase() ? s : '';
}
/** "US$ Dólar americano" (sem repetir o código). */
export function rotuloMoeda(x: string, lang: string = idioma()) {
  const s = simboloMoeda(x), n = nomeMoeda(x, lang);
  return n === x ? (s ? `${s} ${x}` : x) : (s ? `${s} ${n}` : n);
}
/** "US$ Dólar americano · USD" (linha da lista; o código aparece uma vez só). */
export function linhaMoeda(x: string, lang: string = idioma()) {
  const r = rotuloMoeda(x, lang);
  return r === x || r.endsWith(' ' + x) ? r : `${r} · ${x}`;
}
const semAcento = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
/** Blocos da lista: Mais usadas, a moeda do país/idioma (se não estiver nas mais usadas) e Todas (por nome). Com busca, filtra pelos três. */
export function listaMoedas(lang: string, busca = '') {
  const todasCod = [...new Set([...MOEDAS_MAIS_USADAS, ...MOEDAS])];
  const q = semAcento(busca.trim());
  const passa = (x: string) => !q || semAcento(`${nomeMoeda(x, lang)} ${x} ${simboloMoeda(x)}`).includes(q);
  const pais = moedaPadrao();
  const doPais = !MOEDAS_MAIS_USADAS.includes(pais) && todasCod.includes(pais) ? [pais] : [];
  let col: Intl.Collator | null = null;
  try { col = new Intl.Collator(lang); } catch { /* sem Intl.Collator */ }
  const cmp = (a: string, b: string) => { const na = nomeMoeda(a, lang), nb = nomeMoeda(b, lang); return col ? col.compare(na, nb) : semAcento(na).localeCompare(semAcento(nb)); };
  return {
    maisUsadas: MOEDAS_MAIS_USADAS.filter(passa),
    doPais: doPais.filter(passa),
    todas: todasCod.filter(passa).sort(cmp),
  };
}
